<template>
  <div class="" v-if="allCallToActions.length > 0">
    <v-layout row wrap style="margin-left: 1%">
      <v-flex md1 lg1>
        <v-chip label color="#ba7eb8" text-color="white">
          <v-icon left>label</v-icon>Alerts
        </v-chip>
      </v-flex>
      <v-flex md11 lg11>
        <v-chip label color="gray" style="width: 93%">
      <span class="blink">
        {{allCallToActions[count].description}}
      </span>
        </v-chip>
      </v-flex>
    </v-layout>
    <br>
  </div>
</template>

<script>
export default {
  name: 'CallToAction',
  data () {
    return {
      count: -1,
      direction: true
    }
  },
  created () {
    this.$store.dispatch('get_all_call_to_actions')
    setTimeout(this.callToAction(), 1000)
  },
  methods: {
    callToAction: function () {
      var length = this.allCallToActions.length
      if (this.count < length && this.direction === true) {
        this.count = this.count + 1
      } else if (this.count < length && this.direction === true) {
        this.count = this.count - 1
      }
    }
  }
}
</script>

<style scoped>
  @-webkit-keyframes blink {
    from {
      opacity: 1.0;
    }
    to {
      opacity: 0.0;
    }
  }
  .blink {
    -webkit-animation-name: blink;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: cubic-bezier(1.0, 0, 0, 1.0);
    -webkit-animation-duration: 2s;
  }
</style>
